module.exports = __webpack_public_path__ + "img/snv.8a138175.webp";